import ApplicationController from './application_controller'

import QrScanner from 'qr-scanner'

/**
 * Contrôleur Stimulus pour scanner des codes QR
 * Utilise la librairie qr-scanner pour capturer et traiter les codes QR
 */
export default class extends ApplicationController {
  static targets = ['video', 'resourceId', 'resourceType', 'resourceOrderId']

  connect () {
    this.qrScanner = new QrScanner(this.videoTarget, result => this.scannedItem(result))
    this.qrScanner.start()
    this.isProcessing = false
    this.cooldownTime = 2000
  }

  scannedItem (payload) {
    if (this.isProcessing) {
      return
    }

    this.isProcessing = true

    try {
      var data = JSON.parse(payload)

      this.resourceIdTarget.value = data.id
      this.resourceTypeTarget.value = data.type
      // Lot labels and the bon d'enlèvement also print the order: the server
      // falls back to it when the lot itself cannot be found (#8894).
      if (this.hasResourceOrderIdTarget) {
        this.resourceOrderIdTarget.value = data.order_id || ''
      }
      this.resourceTypeTarget.form.submit()
    } catch (error) {
      console.error('Error parsing QR code:', error)
      this.isProcessing = false
    }

    setTimeout(() => {
      this.isProcessing = false
    }, this.cooldownTime)
  }

  disconnect() {
    if (this.qrScanner) {
      this.qrScanner.stop()
    }
  }
}
